import React, { useContext } from 'react'
import { View, Image, Text, Pressable, StyleSheet } from 'react-native';
import { HashLink } from 'react-router-hash-link';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

import {
  blackColor, fontColorWhite,
  routeTop,
  routeTermOfService,
  routePrivacyPolicy,
  routeTokutei,
  routeContact
} from '../../../style/css/CmnStyle';
import { hpContext } from '../HPContext';


function HpFooter() {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;
  const windowDimensions = useContext(hpContext).windowDimensions;

  const windowWidth = windowDimensions.width;


  const onPressTwitter = () => {
    window.open('https://twitter.com/InspireMeAppHub', '_blank');
    //window.open('twitter://user?screen_name=Skaters_app', '_blank');
  }

  const onPressInstagramJa = () => {
    window.open('https://www.instagram.com/inspireme.app.info/', '_blank');
  }

  const onPressInstagramEn = () => {
    window.open('https://www.instagram.com/inspire_me_en/', '_blank');
  }

  return (
    <footer style={styles.container}>
      <View style={[
        styles.container,
        {paddingHorizontal: windowWidth * 0.1},
      ]}>

        <Pressable
          style={styles.logoWrap}
          accessibilityRole="link"
          href={routeTop}
        >
          <Image
            defaultSource={'./assets/img/logo.png'}
            style={isWide? styles.logoImgWide : styles.logoImg}
          />
          <Text style={styles.title}>InspireMe</Text>
        </Pressable>


        <View style={isWide? styles.linkWrapWide : styles.linkWrap}>

          <View style={{marginRight: windowWidth*0.08}}>
            <HashLink
              to={routeTop + '#functions'}
              style={styles.hashLink}
            >
                <Text style={styles.linkTxt}>{t('footer.about')}</Text>
            </HashLink>

            <HashLink
              to={routeTop + '#howto'}
              style={styles.hashLink}
            >
                <Text style={styles.linkTxt}>{t('common.howto')}</Text>
            </HashLink>

            <HashLink
              to={routeTop + '#download'}
              style={styles.hashLink}
            >
                <Text style={styles.linkTxt}>{t('common.download')}</Text>
            </HashLink>
          </View>

          <View style={{marginRight: windowWidth*0.08}}>
            <Pressable accessibilityRole="link" href={routeTokutei}>
              <Text style={styles.linkTxt}>{t('tokusyohou.title')}</Text>
            </Pressable>

            <Pressable accessibilityRole="link" href={routeTermOfService}>
              <Text style={styles.linkTxt}>{t('kiyaku.title')}</Text>
            </Pressable>

            <Pressable accessibilityRole="link" href={routePrivacyPolicy}>
              <Text style={styles.linkTxt}>{t('policy.title')}</Text>
            </Pressable>

            <Pressable accessibilityRole="link" href={routeContact}>
              <Text style={styles.linkTxt}>{t('contact.title')}</Text>
            </Pressable>
          </View>

          <View style={{marginRight: windowWidth*0.08}}>
            <Text style={isWide? styles.snsTitleWide : styles.snsTitle}>Follow</Text>
            <Pressable style={styles.snsLinkWrap} accessibilityRole="link" onPress={onPressTwitter}>
              <FaXTwitter size={18} color={fontColorWhite} />
              <Text style={[styles.linkTxt, {marginLeft: 5}]}>X(Twitter)</Text>
            </Pressable>

            <Pressable style={styles.snsLinkWrap} accessibilityRole="link" onPress={onPressInstagramEn}>
              <FaInstagram size={18} color={fontColorWhite} />
              <Text style={[styles.linkTxt, {marginLeft: 5}]}>Instagram(EN)</Text>
            </Pressable>

            <Pressable style={styles.snsLinkWrap} accessibilityRole="link" onPress={onPressInstagramJa}>
              <FaInstagram size={18} color={fontColorWhite} />
              <Text style={[styles.linkTxt, {marginLeft: 5}]}>Instagram(JA)</Text>
            </Pressable>
          </View>

        </View>

      </View>
    </footer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    backgroundColor: blackColor,
    paddingVertical: 50,
    flexShrink: 0,
  },

  logoWrap: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoImg: {
    width: '11vw',
    height: '11vw',
    marginRight: 5,
    borderRadius: 10,
  },
  logoImgWide: {
    width: '4vw',
    height: '4vw',
    marginRight: 10,
    borderRadius: 10,
  },
  title: {
    color: fontColorWhite,
    fontSize: '1.3em',
    fontWeight: 'bold',
  },

  linkWrap: {
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  linkWrapWide: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 10,
    paddingVertical: 10,
  },

  hashLink: {
    display: 'flex',
    textDecorationColor: 'transparent',
  },
  linkTxt: {
    color: fontColorWhite,
    fontSize: '0.8em',
    marginVertical: 10,
  },

  snsLinkWrap: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  snsTitleWide: {
    color: fontColorWhite,
    fontSize: '0.9em',
    fontWeight: 'bold',
    marginBottom: 10,
  },
  snsTitle: {
    color: fontColorWhite,
    fontSize: '0.9em',
    fontWeight: 'bold',
    marginTop: 25,
    marginBottom: 5,
  },
})

export default HpFooter;
